import React from "react";

import {
  Button,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { Logo } from "@hubcapp/components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: "10vh",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    background: "#F2F2F2",
    height: "100vh",
  },
  logoContainer: {
    marginBottom: theme.spacing(7),
    display: "flex",
    justifyContent: "center",
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
}));

const Error401 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.root} title="Error 401">
      <Grid container justify="center" className={classes.logoContainer}>
        <Logo />
      </Grid>
      <Typography align="center" variant={mobileDevice ? "h4" : "h1"}>
        You&apos;re not signed in.
      </Typography>
      <Grid container justify="center" className={classes.buttonContainer}>
        <Button
          color="primary"
          component={RouterLink}
          to="/auth/sign-in"
          variant="contained"
        >
          Go to sign in
        </Button>
      </Grid>
    </div>
  );
};

export default Error401;
